<div class="item-grabber">
  <rt-icon name="drag-vertical"></rt-icon>
</div>

<div class="item-content">
  <div *ngIf="!titleEditorOpen" class="item-title-actions">
    <div class="item-title">
      {{ title }}
    </div>
    <div *ngIf="editable" class="item-actions">
      <rt-group>
        <rt-icon-button
          *ngIf="renamable"
          (click)="onEditItemClick()"
          iconName="edit"
          shape="square"
          variant="plain"
        >
        </rt-icon-button>
        <rt-icon-button
          *ngIf="removable"
          [loading]="processing"
          (click)="onDeleteItemClick()"
          variant="plain"
          iconName="delete"
          shape="square"
          class="danger-on-hover"
        >
        </rt-icon-button>
      </rt-group>
    </div>
  </div>
  <rt-list-sortable-form
    *ngIf="titleEditorOpen"
    [value]="title"
    (cancelClick)="onCancelClick()"
    (saveClick)="onEditName($event)"
  >
  </rt-list-sortable-form>
</div>
